import { TIME } from "../constants";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";

export default function TimeRangePicker(props) {
  const { time } = props;

  const from = time.split("-")?.[0]?.trim() || "";
  const to = time.split("-")?.[1]?.trim() || from || "";

  return (
    <Box sx={{ display: "flex", minWidth: 0, width: "100%" }}>
      <FormControl fullWidth required sx={{ minWidth: 0 }}>
        <InputLabel id="from-label">From</InputLabel>
        <Select
          value={from}
          labelId="from-label"
          label="From"
          id="from"
          name="from"
          onChange={(e) => {
            props.onChange({
              from: e.target.value,
              to: TIME[Math.min(TIME.indexOf(e.target.value) + 1, TIME.length - 1)],
            });
            document.activeElement.blur();
          }}
        >
          {TIME.map((o, idx) => {
            return (
              <MenuItem key={idx} value={o}>
                {o}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      <FormControl variant="outlined" fullWidth required sx={{ minWidth: 0 }}>
        <InputLabel id="to-label">To</InputLabel>
        <Select
          value={to}
          labelId="to-label"
          label="To"
          id="to"
          name="to"
          onChange={(e) => {
            props.onChange({ from, to: e.target.value });
            document.activeElement.blur();
          }}
        >
          {TIME.map((o, idx) => {
            return (
              <MenuItem key={idx} value={o} disabled={idx < TIME.indexOf(from)}>
                {o}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Box>
  );
}
